const BASE = '/app/users';

export const USERS_GROUP_LINKS = {
	BASE,
	LINK_USER_DETAILS: BASE.concat('/:id'),
	LINK_USER_DETAILS_TEAMS: BASE.concat('/:id/teams'),
	LINK_USER_DETAILS_LEAGUES: BASE.concat('/:id/leagues')
};